export const signUpInitialValues = {
  name: '',
  email: '',
  web3: '',
  couponName: '',
  phoneNumber: '',
  discord: '',
  telegram: '',
  twitter: '',
  youtube: '',

}

export const presaleInitialValues = {

  "refrenceAddress": "",
  "investedamount": "",
  "returnamount": "0",
  "exchangelistingprice": "",
  "paymentMode": "XXXX",
  "privatesale": "",
  "publicsale": "",
}

export const couponInitialValues = {
  "name": "",
  "email": "",
  "telegramAddress": "",
  "couponCode": "",
  "isValidCoupon": false,
  "investorAddress": "",
}